"use client";

import { useEffect, useRef } from "react";

const contactIframe = `<iframe data-tally-src="https://tally.so/embed/wg48WO?alignLeft=1&hideTitle=1&transparentBackground=1&dynamicHeight=1" loading="lazy" width="100%" style="min-height: 700px;" frameborder="0" marginheight="0" marginwidth="0" title="Contact form"></iframe><script>var d=document,w="https://tally.so/widgets/embed.js",v=function(){"undefined"!=typeof Tally?Tally.loadEmbeds():d.querySelectorAll("iframe[data-tally-src]:not([src])").forEach((function(e){e.src=e.dataset.tallySrc}))};if("undefined"!=typeof Tally)v();else if(d.querySelector('script[src="'+w+'"]')==null){var s=d.createElement("script");s.src=w,s.onload=v,s.onerror=v,d.body.appendChild(s);}</script>`;

const ContactPage = () => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    const loadTallyEmbed = () => {
      if (typeof (window as any).Tally !== "undefined") {
        (window as any).Tally.loadEmbeds();
      } else {
        // Tallyスクリプトがまだ読み込まれていない場合、読み込みを試みる
        const script = document.createElement("script");
        script.src = "https://tally.so/widgets/embed.js";
        script.async = true;
        script.onload = () => (window as any).Tally.loadEmbeds();
        document.body.appendChild(script);
      }
    };

    // iframeのsrcを設定
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.dataset["tallySrc"] || "";
    }

    // Tallyの埋め込みを読み込む
    loadTallyEmbed();
  }, []);

  return (
    <div className="max-w-6xl mx-auto flex flex-col gap-20">
      <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-wide">
        お問い合わせ
      </h1>
      <div className="w-full max-w-3xl mx-auto px-4">
        <div
          className="w-full"
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: contactIframe }}
        />
      </div>
    </div>
  );
};

export default ContactPage;
